import type { QuestionModule } from "../contracts";
import {
  imageCore,
  type ImageRaw,
  type ImageDefinition,
  type ImageDraft,
  type ImageEvent,
  type ImageResponse,
} from "./core";
import { ImageView } from "./views";

export const imageModule: QuestionModule<
  ImageRaw,
  ImageDefinition,
  ImageDraft,
  ImageEvent,
  ImageResponse
> = {
  type: "image",
  galleryFeatures: ["baseline", "images", "acknowledge", "timed"],
  core: imageCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Image",
      component: ImageView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (definition, _draft, _display, copy) => ({
    ...(definition.numberSeconds <= 0 && !definition.autoResponse
      ? { autoSubmitReady: true }
      : {}),
    ...(definition.numberSeconds <= 0
      ? {
          primaryAction: {
            purpose: "submit" as const,
            label: copy.actions.continue,
            action: { type: "submit" as const },
          },
        }
      : {}),
  }),
};
